<template>
  <svg
    width="29"
    height="21"
    viewBox="0 0 29 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 10.5008C0 10.8635 0.271914 11.1969 0.679786 11.3439L27.0308 20.9126C27.5004 21.0792 28.0443 20.991 28.3903 20.6871C28.7364 20.3831 28.7859 19.942 28.5263 19.589L21.7408 10.491L28.5387 1.40275C28.7982 1.04981 28.7488 0.608631 28.4027 0.30471C28.3903 0.294906 28.378 0.285102 28.3656 0.265494C28.0195 -0.00901561 27.5004 -0.087447 27.0431 0.0792197L0.679786 9.65765C0.271914 9.80471 0 10.138 0 10.5008Z"
      fill="white"
    />
  </svg>
</template>

<script>
  export default {
    name: 'CollaborationRegisterArrow',
  }
</script>
